import { fetchCachedHelper, fetchHelper } from './api'

//The function is here because it's used on beneficiary courses and manage user - user details pages
export const fetchBeneficiaryCourses = async email => {
    const response = await fetchCachedHelper(
        `Beneficiary/GetBeneficiaryCourses/${email}`
    )
    let courses = response.data

    const courseDetails = await Promise.all(
        courses.map(({ coursecode }) => fetchCourseDetails(coursecode))
    )

    courses = courseDetails.map((_, idx) => ({
        ...courses[idx],
        ...(courseDetails[idx] || {}), //So that everything won't fail if just one course has an issue
    }))

    return courses
}

export const fetchClassDetails = async id => {
    const classRes = await fetchCachedHelper(`Inclass/${id}`)
    return classRes.data
}

export const fetchCourseDetails = async coursecode => {
    const courseRes = await fetchCachedHelper(`Course/${coursecode}`)
    return courseRes.data
}
